import { type ReactNode } from "react"
import { Container } from "@/screens/rewards/components/Container"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H4, H6, Small, Tiny } from "@/components/standard/BFText"
import { BFButton } from "@/components/buttons/CommonButtons"
import { router } from "expo-router"
import { preQualLandingPageIntentClick } from "@/analytics/events/preQual"

interface LoanProductCardProps {
  name: string
  icon: ReactNode
  description: string
  className?: string

  ltc: string
  interest: string
  origination: string
  noCta?: boolean
}

export const LoanProductCard = ({
  name,
  description,
  className,
  ltc,
  interest,
  origination,
  icon,
  noCta = false,
}: LoanProductCardProps) => {
  function checkEligibility() {
    preQualLandingPageIntentClick({
      intent: "Loan",
      id: `check-eligibility-${name}`,
      title: "Check Eligibility",
    })
    router.push("/pre-qual/properties-flipped")
  }

  return (
    <Container className={`gap-3 p-3 bg-grey ${className || ""}`}>
      <Horizontal>
        <Vertical className={"flex-1"}>
          <H4 color={"default"}>{name}</H4>
          <Tiny color={"default"}>{description}</Tiny>
        </Vertical>
        {icon}
      </Horizontal>
      <Vertical className={"gap-2"}>
        <Horizontal className={"justify-between items-center"}>
          <Small color={"default"}>LTC</Small>
          <H6 color={"default"}>{ltc}</H6>
        </Horizontal>
        <Horizontal className={"justify-between items-center"}>
          <Small color={"default"}>Interest</Small>
          <H6 color={"default"}>{interest}</H6>
        </Horizontal>
        <Horizontal className={"justify-between items-center"}>
          <Small color={"default"}>Origination</Small>
          <H6 color={"default"}>{origination}</H6>
        </Horizontal>
        {!noCta && (
          <BFButton
            onPress={checkEligibility}
            title={"Check Eligibility"}
            variant={"secondary"}
            size={"sm"}
            testID={`check-eligibility-${name}`}
          />
        )}
      </Vertical>
    </Container>
  )
}
